import React, { useEffect, useState } from "react";
import logo from "../../assets/windTree/images/login/logowbg.webp";
import logowbg from "../../assets/windTree/images/nav/logowbg1.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { persistor } from "../redux/store/store";
import { Blinds, Mail, ShoppingCart,Heart, Home, HomeIcon, UserCircle} from "lucide-react";
import { Phone  } from "lucide-react";
import {
  IoSearch,
  IoMenuSharp,
  IoClose,
} from "react-icons/io5";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaXTwitter,
  FaYoutube,
  FaPhoneFlip,
} from "react-icons/fa6";
import { FaEnvelope, FaTools } from "react-icons/fa";
import {
  FaHeadphones,
  FaSearchLocation,
  FaUserPlus,
  FaUser,
  FaShopify
} from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { Badge, Circle, position } from "@chakra-ui/react";
import {
  FaTachometerAlt,
  FaMapMarkerAlt,
  FaSignOutAlt,
} from "react-icons/fa";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { logout } from "../redux/reduxSlice/SingIn&Singup/SingInSlice";
import { getwebsiteProduct } from "../redux/reduxApi/website/ProductReduxApi";
import { clearCartLocal } from "../redux/reduxSlice/website/CartSlice";
import { getCartProductsWebuser } from "../redux/reduxApi/website/CartProductCount";
import { clearCartData } from "../redux/reduxSlice/website/WebUserCartSlice";
import { getWishlistProducts } from "../redux/reduxApi/website/WishlistApi";
import useShadeSearch from "../hook/useShadeSearch";
import { AsyncPaginate } from "react-select-async-paginate";

const NavBar = ({ item }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false); // State for search bar visibility
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isTop, setIsTop] = useState(false);
  const wishlistCount = useSelector((state) => state.Wishlist?.wishlist?.length || 0);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const { loadShades } = useShadeSearch();

const [emailForm, setEmailForm] = useState({
  email: "",
  shades: null,
  description: "",
});



  console.log("Wishlist Count in Navbar:", wishlistCount);
  const cart = useSelector((state) => {
    if (state.CartProducts?.data && Array.isArray(state.CartProducts.data)) {
      return state.CartProducts.data;
    }
    if (
      state.Cart?.CartProducts?.data &&
      Array.isArray(state.Cart.CartProducts.data)
    ) {
      return state.Cart.CartProducts.data;
    }

    return [];
  });

  const cartCount = cart.length;

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("UserRowId");
    setAuthToken(token);
    if (token && userId) {
      dispatch(getCartProductsWebuser())
        .unwrap()
        .then((result) => {
          console.log("Cart fetch result:", result);
        })
        .catch((error) => {
          console.error("Error fetching cart:", error);
        });
      // Fetch wishlist on mount for real-time count
      dispatch(getWishlistProducts())
        .unwrap()
        .then((result) => {
          console.log("Wishlist fetch result:", result);
        })
        .catch((error) => {
          console.error("Error fetching wishlist:", error);
        });
    }
  }, [authToken]);

  const navigate = useNavigate();
  const userNameData = localStorage.getItem("userName");
  let userName = "";

  const handleShadeClick = (shadeName) => {
    navigate(`/shop?shadeName=${encodeURIComponent(shadeName)}`);
  };

  try {
    const parsed = JSON.parse(userNameData);
    if (parsed && typeof parsed === "object") {
      userName = parsed.firstName || parsed.name || parsed.username || "";
    } else {
      userName = parsed || "";
    }
  } catch (e) {
    userName = userNameData || "";
  }

  const handleServices = () => {
    setIsServiceOpen(!isServiceOpen);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const openDrawer = () => {
    setIsOpen(true);
  };

  const toggleSearchBar = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const handleDropdownClick = (e) => {
    e.preventDefault();
    setIsHovered(false);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  // useEffect(() => {
  //   const data = localStorage.getItem("authToken");
  //   setAuthToken(data);
  // }, []);

  useEffect(() => {
    if (location.pathname === "/homepage") {
      const handleScroll = () => {
        if (window.scrollY === 0) {
          console.log("Scroll at top - setting isTop true");
          setIsTop(true);
        } else {
          console.log("Scroll not at top - setting isTop false");
          setIsTop(false);
        }
      };
      window.addEventListener("scroll", handleScroll);
      // Initial check
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    } else {
      setIsTop(false);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("UserRowId");
    localStorage.removeItem("redirect");
    localStorage.removeItem("userObj");
    localStorage.removeItem("user");
    localStorage.removeItem("userName");
    localStorage.removeItem("UserName");
    localStorage.removeItem("addedProducts");
    localStorage.removeItem("userEmail");
    dispatch(clearCartData());
    dispatch(clearCartLocal());
    dispatch({ type: "wishlist/clearWishlist" });
    dispatch(logout());
    persistor.purge();
    setAuthToken(null);
    toast.success("Logged out successfully");
    setTimeout(() => {
      window.location.href = "/login";
    }, 100);
  };

  // handle search results
  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    try {
      const response = dispatch(
        getwebsiteProduct({
          search: [
            {
              field: "name",
              operation: "like",
              value: value,
            },
          ],
        }),
      );
      console.log("response of global search response on website ", response);
    } catch (error) {
      console.error("Error fetching global search data:", error);
    }
  };

  const clearSearch = () => {
    dispatch(getwebsiteProduct());
    setSearchTerm("");
  };

  // const handleSearchSubmit = (e) => {
  //   if (e.key === "Enter") {
  //     if (searchTerm.trim()) {
  //       navigate(`/shop?search=${searchTerm}`);
  //     }
  //   }
  // };

const handleSearchSubmit  = () => {
  if (searchTerm.trim()) {
    navigate(`/shop?search=${searchTerm}`);
  }
};

  return (
    <>
      {/* <div
        className={`fixed w-full scrollbar top-0 z-30 transition-colors duration-500 ease-in-out ${isTop
            ? "bg-transparent text-white"
            : "bg-[#f7f7f7] text-[#661e33] border-b border-black-700"
          }`}
      > */}
      <div
        className={`fixed w-full scrollbar top-0 z-30 transition-colors duration-500 ease-in-out bg-[#f7f7f7] text-[#661e33] border-b border-black-700`}
      >
        <nav
          className={`py-2 border-b flex justify-between items-center transition-all duration-500 ${isTop
              ? "bg-transparent text-[#661e33] border-transparent"
              : "bg-[#f7f7f7] text-[#661e33] border-black-700 shadow-md"
            }`}
          style={{ height: `${isSearchOpen ? "120px" : "75px"}` }}
        >
          <div className="container mobile flex justify-between items-center md:mx-4 w-full">
            <div className="flex-shrink-0 inline-block group">
              <Link to="/homepage" className="relative">
                <img
                  src={logo}
                  alt="Mobex Logo"
                  className="inline-block h-12 md:h-16 lg:mx-0 md:m-0"
                  style={{ position: "relative" }}
                />
                <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 !bg-black !text-white text-md px-2 py-1 rounded opacity-0 group-hover:!opacity-100 transition-opacity duration-300 z-[999]">
                  Home
                </span>
              </Link>
            </div>
            <div className="hidden lg:flex justify-between items-center flex-1">
              
              <div className="flex justify-center items-center gap-8 mx-auto">

              <Link to="/homepage" 
               className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}>
                      <div className="relative group flex items-center gap-1 text-lg font-semibold">
                  
              Home
                      </div>
              </Link>

              
       
 <div className="relative group">
  <Link
    to="/productpage"
    className="flex items-center px-0 py-2 text-[#661e33]"
  >
    <div className="flex items-center gap-1 cursor-pointer text-lg font-semibold">
    
      Product
    </div>
  </Link>

  {/* Dropdown */}
  <div
 
    className="
      absolute left-0 top-full
      w-80
      bg-white
      rounded-lg
      border border-gray-200
      shadow-xl
      z-[99999]

      hidden
      group-hover:block
    "
  >
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-t-lg
      "  onClick={() => handleShadeClick("MONSOON / INDUSTRIAL PVC BLINDS")}
    >
      MONSOON / INDUSTRIAL PVC BLINDS
    </div>

    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      "  onClick={() => handleShadeClick("ROLLER BLINDS")}
    >
      ROLLER BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      "   onClick={() => handleShadeClick("ZEBRA BLINDS")}
    >
      ZEBRA BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      " onClick={() => handleShadeClick("DREAM BLINDS")}
    >
      DREAM BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      " onClick={() => handleShadeClick("TRIPLE BLINDS")}
    >
      TRIPLE BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      " onClick={() => handleShadeClick("WOODEN BLINDS")}
    >
      WOODEN BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      " onClick={() => handleShadeClick("INSULATED GLASS BLINDS (Sandwich Blinds)")}
    >
      INSULATED GLASS BLINDS (Sandwich Blinds)
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      " onClick={() => handleShadeClick("SKYLIGHT BLINDS")}
    >
      SKYLIGHT BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      " onClick={() => handleShadeClick("ROMAN BLINDS")}
    >
      ROMAN BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      "   onClick={() => handleShadeClick("MOTORIZED CURTAIN TRACKER")}
    >
      MOTORIZED CURTAIN TRACKER
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      "  onClick={() => handleShadeClick("LEATHERITE BLINDS")}
    >
     LEATHERITE BLINDS
    </div>
    <div
      className="
        px-4 py-2
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-b-lg
      "  onClick={() => handleShadeClick("PLEATED MOSQUITO MESH")}
    >
     PLEATED MOSQUITO MESH
    </div>
  </div>
</div>

 <div className="relative group">
   <div
    className="flex items-center px-0 py-2 text-[#661e33]"
  >
    <div className="flex items-center gap-1 cursor-pointer text-lg font-semibold">
    
      Services
    </div>
    </div>

     <div
 
    className="
      absolute left-0 top-full
      w-72
      bg-white
      rounded-lg
      border border-gray-200
      shadow-xl
      z-[99999]

      hidden
      group-hover:block
    "
  >

    <div
      className="
        px-4 py-3
        text-sm text-[#661e33]
        hover:bg-gray-100
        cursor-pointer
        rounded-t-lg
      "    onClick={() => navigate("/services")}
    >
      Window Blinds Installation Service
    </div>

  </div>
  
 </div>


   <Link
                  to="/shop"
                  className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}
                >
                  <div className="relative group flex items-center gap-1 text-lg font-semibold"> {/* Added group class here */}
                    Shop
                    {/* Added tooltip span */}
                    {/* <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 !bg-black !text-white text-md px-2 py-1 rounded opacity-0 group-hover:!opacity-100 transition-opacity duration-300 z-[999] whitespace-nowrap">
                      Shop
                    </span> */}
                  </div>
                </Link>



              <Link to="/about-us" 
               className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}>
                      <div className="relative group flex items-center gap-1 text-lg font-semibold">
                        
              About
                      </div>
              </Link>
              <Link to="/flipbook" 
               className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}>
                      <div className="relative group flex items-center gap-1 text-lg font-semibold">
                        
              Flipbook
                      </div>
              </Link>
              <Link to="/contact-us" 
               className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}>
                      <div className="relative group flex items-center gap-1 text-lg font-semibold">
                        
              Contact Us
                      </div>
              </Link>
            


                {/* <Link
                  to="/shop"
                  className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}
                >
                  <div className="relative">
                    <FaShopify
                      size="22px"
                      color="#661e33"
                      className="hover:scale-105"

                    />

                  </div>


                </Link>


                 */}
             


              
              </div>

              <div className="flex items-center gap-6 ml-auto">

                 {/* <button
                              className="group inline-flex items-center gap-2 bg-[#661e33] text-white px-3 sm:px-2 py-2.5 sm:py-3 rounded-full font-semibold transition-all duration-300 hover:bg-[#582635] hover:shadow-lg text-xs sm:text-base border border-[#D1BC9F]/40"
                              onClick={() => setIsEmailModalOpen(true)}
                            >
                                <FaEnvelope className="w-4 h-4" />
                              Send Email
                            </button> */}
                
                <div className="relative flex items-center bg-white w-[250px] border border-gray-300 text-black px-3 py-1 rounded-xl shadow-sm focus-within:ring-2 focus-within:ring-[#dff7eb] focus-within:border-[#dff7eb] transition duration-200">
                  {/* Left Icon */}
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    rotation={90}
                    className="text-gray-400 mr-2 cursor-pointer"
                    onClick={handleSearchSubmit}
                  />

                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
                    className="flex-1 outline-none bg-transparent pr-8"
                  />

                  {/* Right Logo */}
                  <img
                    src={logowbg}
                    alt="Logo"
                    className="absolute right-0 w-7 h-7 object-contain"
                  />

                </div>

                  
  <Link
                  to="/account/wishlist"
                  className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}
                >
                  <div className="relative group flex items-center gap-1">
                    <Heart  className="text-xl hover:scale-105" />
                    {wishlistCount > 0 && authToken && (
                      <span className="absolute -top-1 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full px-0 py-0.5 min-w-[18px] text-center leading-none">
                        {wishlistCount}
                      </span>
                    )}  
                    <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 !bg-black !text-white text-md px-2 py-1 rounded opacity-0 group-hover:!opacity-100 transition-opacity duration-300 z-[999] whitespace-nowrap">
                      Wishlist
                    </span>


                  </div>
                </Link>

            




                <Link
                  to="/addtocart"
                  className="flex items-center px-0 py-2 text-[#661e33]"
                  onClick={() => setDropdownVisible(false)}
                >
                  <div className="relative group">
                    <ShoppingCart className="text-xl hover:scale-105" />
                    {cartCount > 0 && authToken && (
                      <span className="absolute -top-1 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full px-0 py-0.5 min-w-[18px] text-center leading-none">
                        {cartCount}
                      </span>
                    )}
                    <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 !bg-black !text-white text-md px-2 py-1 rounded opacity-0 group-hover:!opacity-100 transition-opacity duration-300 z-[999] whitespace-nowrap">
                      Add to Cart
                    </span>
                  </div>
                </Link>
                {authToken === null ? (
                  <div
                    className="flex flex-end items-center"
                    style={{ position: "relative", right: "4px" }}
                  >
                    <Link
                      to="/login"
                      className="text-white-500 no-underline font-bold"
                    >
                      <button
                        className="relative group text-white font-bold no-underline cursor-pointer flex items-center whitespace-nowrap !pt-1"
                        type="button"
                        onClick={toggleDropdown}
                        style={{ position: "relative", right: "1px" }}
                      >
                        <FaUserPlus
                          size="25px"
                          color="#661e33"
                          className="hover:scale-105"
                        />
                        <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 !bg-black !text-white text-md px-2 py-1 rounded opacity-0 group-hover:!opacity-100 transition-opacity duration-300 z-[999] whitespace-nowrap">
                          Login
                        </span>
                      </button>
                    </Link>
                  </div>
                ) : (
                  <Link
                    to="/account/dashboard"
                    className="relative group no-underline font-bold"
                  >
                    <button
                      className="relative text-white font-bold pl-2 no-underline cursor-pointer flex items-center whitespace-nowrap "
                      type="button"
                      aria-label="User"
                      // onClick={toggleDropdown}
                      style={{ position: "relative", right: "1px" }}
                    >

                      <FaUser
                        size="22px"
                        color="#661e33"
                        className="hover:scale-105"
                      />

                    </button>

                  </Link>

                )}



              </div>


            </div>

            {/* for mobile start */}
            <div className="flex lg:hidden items-center">
              {/* <button
                className="text-white px-2 py-2 h-12 rounded-lg"
                onClick={toggleSearchBar}
              >
                <IoSearch size="30px" />
              </button> */}
              <div className="flex">
                <div className="flex items-center gap-1 ">
                  <div className="flex items-center relative">
                    <Link to="/account/wishlist">
                      <Heart  size={"18px"} style={{ marginRight: "-16px" }} />
                      {wishlistCount > 0 && authToken && (
                        <Circle
                          size="3"
                          bg="red"
                          color="white"
                          className="absolute -top-1 -right-5 text-[7px] !text-center"
                        >
                          {wishlistCount}
                        </Circle>
                      )}
                    </Link>
                  </div>
                  
                  <div className="flex flex-bottom relative gap-3 ml-18 mx-6">
                    <Link to="/addtocart">
                      <ShoppingCart size={"18px"} style={{ marginRight: "-16px" }} />
                      {cartCount > 0 && authToken && (
                        <Circle
                          size="3"
                          bg="red"
                          color="white"
                          className="absolute -top-1 start-2 text-[7px] !text-center"
                        >
                          {cartCount}
                        </Circle>
                      )}
                    </Link>
                  </div>

                  {authToken === null ? (
                    <div
                      className="flex flex-end items-center pt-1"
                      style={{ position: "relative" }}
                    >
                      <Link
                        to="/login"
                        className="text-white-500 no-underline font-bold"



                      >
                        <button
                          className="relative text-white-500 no-underline font-bold"
                          type="button"
                        >
                          {/* Login  */}
                          <FaUserPlus
                            size="22px"
                            color="#661e33"
                            className="hover:scale-105"


                          />

                        </button>

                      </Link>
                    </div>
                  ) : (
                    <Link className="relative no-underline font-bold">
                      <button
                        className="relative text-[#661e33] font-bold no-underline cursor-pointer flex items-center whitespace-nowrap "
                        type="button"
                        onClick={toggleDropdown}
                        style={{ position: "relative", right: "1px" }}
                      >
                        <FaUser size="18px" />
                      </button>
                      {dropdownVisible && (
                        <div className="absolute right-0 mt-2 w-[190px] bg-white shadow-lg rounded-md z-10">
                          <Link
                            to="/account/dashboard"
                            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                            onClick={() => setDropdownVisible(false)}
                          >
                            <FaTachometerAlt className="mr-2 text-sm" />
                            Dashboard
                          </Link>
                          <Link
                            to="/account/wishlist"
                            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                            onClick={() => setDropdownVisible(false)}
                          >
                            <Heart  className="mr-2 text-sm" />
                            Wishlist
                          </Link>
                          <Link
                            to="/account/orders"
                            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                            onClick={() => setDropdownVisible(false)}
                          >
                            <FaShopify  className="mr-2 text-sm" />
                            Orders
                          </Link>
                          <Link
                            to="/account/edit-address"
                            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                            onClick={() => setDropdownVisible(false)}
                          >
                            <FaMapMarkerAlt className="mr-2 text-sm" />
                            Addresses
                          </Link>
                          <Link
                            to="/account/edit-account"
                            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                            onClick={() => setDropdownVisible(false)}
                          >
                            <FaUser className="mr-2 text-sm" />
                            Account details
                          </Link>

                          <Link
                            className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200 border-t"
                            onClick={() => {
                              handleLogout();
                              setDropdownVisible(false);
                            }}
                          >
                            <FaSignOutAlt className="mr-2 text-sm" />
                            Log out
                          </Link>
                        </div>
                      )}
                    </Link>
                  )}
                  <button className=" text-[#661e33] " onClick={openDrawer}>
                    <IoMenuSharp className="h-6 w-6" />
                  </button>
                </div>
              </div>
            </div>
            {/* for mobile end */}
          </div>
        </nav>
        {/* for mobile  */}
        <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
          <DrawerOverlay>
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader style={{ fontWeight: "bold" }}>Menu</DrawerHeader>
              <DrawerBody>
                <div className="flex flex-col items-center mt-2 w-full h-screen divide-y divide-slate-200">
                  <Link
                    to="/homepage"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Home</div>
                  </Link>
                  <Link
                    to="/productpage"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Product</div>
                  </Link>
                  <Link
                    to="/services"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Services</div>
                  </Link>
                  <Link
                    to=""
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer flex justify-between"
                    onClick={() => {
                      setIsHovered(!isHovered);
                    }}
                  >
                    {/* <div className="w-full p-2 hover:bg-[#EFF6FF] relative flex justify-between">
                      Services {isHovered ? <ChevronDown /> : <ChevronUp />}
                      {isHovered && (
                        <div
                          id="dropdownHover"
                          // onMouseLeave={() => setIsHovered(false)}
                          className="w-full divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700 absolute top-10 mt-2 transform transition-all duration-200 ease-out opacity-100 translate-y-0"
                        >
                          <ul
                            className="py-2 px-3 text-sm text-gray-700 dark:text-gray-200"
                            aria-labelledby="dropdownHoverButton"
                          >
                            <li onClick={onClose}>
                              <Link
                                to="/breaks"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Breaks
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/clutch"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Clutch & Transmissions
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <a
                                href="#electrical"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Electrical
                              </a>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/engine"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Engine Diagnostics
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/exhaust"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline text-shadow"
                              >
                                Exhaust
                              </Link>
                            </li>

                            <li onClick={onClose}>
                              <Link
                                to="/fuel"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Fuel
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/maintenance"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Maintenance
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/radiators"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Radiators & Cooling
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/suspension"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Suspension & Steering
                              </Link>
                            </li>
                            <li onClick={onClose}>
                              <Link
                                to="/transfer"
                                className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline"
                              >
                                Transfer Case & Differentials
                              </Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div> */}
                  </Link>
                  <Link
                    to="/shop"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">Shop</div>
                  </Link>

                  <Link
                    to="/blog"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    {/* <div className="w-full p-2 hover:bg-[#EFF6FF]">Blogs</div> */}
                  </Link>
                  <Link
                    to="/about-us"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">
                      About
                    </div>
                  </Link>
                  <Link
                    to="/flipbook"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">
                      Flipbook
                    </div>
                  </Link>
                  <Link
                    to="/contact-us"
                    className="w-full text-lg font-bold text-gray-800 no-underline cursor-pointer"
                    onClick={onClose}
                  >
                    <div className="w-full p-2 hover:bg-[#EFF6FF]">
                      Contact us
                    </div>
                  </Link>
                </div>
              </DrawerBody>
            </DrawerContent>
          </DrawerOverlay>
        </Drawer>

        {isEmailModalOpen && (
  <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">

    {/* Modal */}
    <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden">

      {/* Header */}
      <div className="bg-[#661e33] px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 text-white">
          <FaEnvelope className="text-lg" />
          <h2 className="text-xl font-semibold">
            Send Email
          </h2>
        </div>

        <button
          type="button"
          onClick={() => setIsEmailModalOpen(false)}
          className="text-white hover:text-gray-200 text-2xl leading-none"
        >
          ×
        </button>
      </div>

      {/* Form */}
      <form
        className="p-6 space-y-5"
      >

        {/* Email */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Email
          </label>

         <input 
  type="email"
  name="email"
  value={emailForm.email}
  onChange={(e) =>
    setEmailForm({
      ...emailForm,
      email: e.target.value,
    })
  }
  placeholder="Enter your email"
  className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none focus:border-[#661e33] focus:ring-2 focus:ring-[#661e33]/10 transition" 
  required
/>
        </div>
        {/* Email */}
       <div>
  <label className="block text-sm font-semibold text-gray-700 mb-2">
    Shades
  </label>

  <AsyncPaginate
    name="shades"
    value={emailForm.shades}
    loadOptions={loadShades}
    additional={{ page: 1 }}
    isClearable
    isSearchable
    placeholder="Select Shades"
    onChange={(selectedOption) => {
      setEmailForm((prev) => ({
        ...prev,
        shades: selectedOption,
      }));
    }}
    className="w-full"
    styles={{
      control: (base, state) => ({
        ...base,
        minHeight: "48px",
        borderRadius: "8px",
        borderColor: state.isFocused ? "#661e33" : "#d1d5db",
        boxShadow: state.isFocused
          ? "0 0 0 1px #661e33"
          : "none",
        "&:hover": {
          borderColor: "#661e33",
        },
      }),
      option: (base, state) => ({
        ...base,
        color: "#661e33",
        backgroundColor: state.isSelected
          ? "#661e33"
          : state.isFocused
          ? "#f3e8ec"
          : "#ffffff",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#661e33",
      }),
    }}
  />
</div>

        {/* Description */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Description
          </label>

         <textarea 
  name="description"
  value={emailForm.description}
  onChange={(e) =>
    setEmailForm({
      ...emailForm,
      description: e.target.value,
    })
  }
  placeholder="Enter your message..."
  rows={5}
  className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none resize-none focus:border-[#661e33] focus:ring-2 focus:ring-[#661e33]/10 transition" 
  required
/>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 pt-2">

          <button
            type="button"
            onClick={() => setIsEmailModalOpen(false)}
            className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition"
          >
            Cancel
          </button>

          <button
            type="submit"
            className="px-5 py-2.5 rounded-lg bg-[#661e33] text-white font-semibold hover:bg-[#582635] transition flex items-center gap-2"
          >
            <FaEnvelope />
            Send Email
          </button>

        </div>

      </form>
    </div>
  </div>
)}
      </div>
    </>
  );
};

export default NavBar;

// import React, { useEffect, useState } from "react";
// import logo from "../../assets/windTree/images/login/logowbg.png";
// import logowbg from "../../assets/windTree/images/nav/logowbg1.png"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
// import { Link, useNavigate } from "react-router-dom";
// import { persistor } from "../redux/store/store";
// import { Blinds, Mail } from "lucide-react";
// import { Phone } from "lucide-react";
// import { IoSearch, IoCart, IoMenuSharp, IoClose, IoHeart } from "react-icons/io5";
// import { FaFacebookF, FaLinkedinIn, FaInstagram, FaXTwitter, FaYoutube, FaPhoneFlip } from "react-icons/fa6";
// import { FaTools } from "react-icons/fa";
// import { FaHeadphones, FaSearchLocation, FaUserPlus, FaUser } from "react-icons/fa";
// import { FaPhone } from "react-icons/fa6";
// import { Badge, Circle, position } from "@chakra-ui/react";
// import { FaTachometerAlt, Heart , FaShoppingCart, FaMapMarkerAlt, FaSignOutAlt, FaShopify   } from "react-icons/fa";
// import { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, Button } from "@chakra-ui/react";
// import { useDispatch, useSelector } from "react-redux";
// import { singIn } from "../redux/reduxApi/SingIn&SingUp/SinginApi";
// import toast from "react-hot-toast";
// import { useLocation } from "react-router-dom";
// import { logout } from "../redux/reduxSlice/SingIn&Singup/SingInSlice";
// import { getwebsiteProduct } from "../redux/reduxApi/website/ProductReduxApi";
// import { ChevronDown, ChevronUp, Clock } from "lucide-react";
// import { clearCartLocal } from "../redux/reduxSlice/website/CartSlice";
// import { getCartProductsWebuser } from "../redux/reduxApi/website/CartProductCount";
// import { clearCartData } from "../redux/reduxSlice/website/WebUserCartSlice";
// const NavBar = ({ item }) => {
//   const location = useLocation();
//    const dispatch = useDispatch();
//   const [isOpen, setIsOpen] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false); // State for search bar visibility
//   const [isServiceOpen, setIsServiceOpen] = useState(false);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [authToken, setAuthToken] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isTop, setIsTop] = useState(false);
//     const wishlistData = useSelector((state) => state.Wishlist.WishListProducts.wishlist);
//     const wishlistCount = wishlistData.length
//  const cart = useSelector((state) => {
//     console.log("CartProducts state:", state.CartProducts);

//     // Access data from CartProducts slice
//     if (state.CartProducts?.data && Array.isArray(state.CartProducts.data)) {
//       return state.CartProducts.data;
//     }

//     // Fallback to Cart slice if needed
//     if (state.Cart?.CartProducts?.data && Array.isArray(state.Cart.CartProducts.data)) {
//       return state.Cart.CartProducts.data;
//     }

//     return [];
//   });

//   const cartCount = cart.length;
//   console.log("Final cart from Redux:", cartCount);
//   useEffect(() => {
//     const token = localStorage.getItem("authToken");
//     const userId = localStorage.getItem("UserRowId");
//     setAuthToken(token);

//     // If user is logged in, fetch their cart
//     if (token && userId) {
//         dispatch(getCartProductsWebuser())
//             .unwrap()
//             .then((result) => {
//                 console.log("Cart fetch result:", result);
//             })
//             .catch((error) => {
//                 console.error("Error fetching cart:", error);
//             });
//     }
// }, [dispatch]);

//   // const guestCartCount = useSelector((state) => state.Cart.guestCartCount || 0);
//   const navigate = useNavigate();
//   // const wishlistCount = useSelector((state) => state.Wishlist.WishListCount.count || 0);

//  // Replace line 46 with:
// const userNameData = localStorage.getItem("userName");
// let userName = "";

// try {
//   // Try to parse it as JSON
//   const parsed = JSON.parse(userNameData);
//   // If it's an object with properties, extract the name
//   if (parsed && typeof parsed === 'object') {
//     userName = parsed.firstName || parsed.name || parsed.username || "";
//   } else {
//     userName = parsed || "";
//   }
// } catch (e) {
//   // If it's not JSON, use it as a string
//   userName = userNameData || "";
// }

//   const handleServices = () => {
//     setIsServiceOpen(!isServiceOpen);
//   };

//   const onClose = () => {
//     setIsOpen(false);
//   };

//   const openDrawer = () => {
//     setIsOpen(true);
//   };

//   const toggleSearchBar = () => {
//     setIsSearchOpen(!isSearchOpen);
//   };

//   const handleDropdownClick = (e) => {
//     e.preventDefault();
//     setIsHovered(false);
//   };
//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   };

//   // useEffect(() => {
//   //   dispatch();
//   // });

//   useEffect(() => {
//     const data = localStorage.getItem("authToken");
//     setAuthToken(data);
//   }, []);  // Remove authToken from dependencies

//   useEffect(() => {
//     // Only add scroll listener on homepage
//     if (location.pathname === "/homepage") {
//       const handleScroll = () => {
//         if (window.scrollY === 0) {
//           console.log("Scroll at top - setting isTop true");
//           setIsTop(true);
//         } else {
//           console.log("Scroll not at top - setting isTop false");
//           setIsTop(false);
//         }
//       };
//       window.addEventListener("scroll", handleScroll);
//       // Initial check
//       handleScroll();
//       return () => window.removeEventListener("scroll", handleScroll);
//     } else {
//       setIsTop(false); // For other pages, navbar is opaque
//     }
//   }, [location.pathname]);

//   // logout function for coustomer
//  const handleLogout = () => {
//     // Clear localStorage
//     localStorage.removeItem("authToken");
//     localStorage.removeItem("UserRowId");
//     localStorage.removeItem("redirect");
//     localStorage.removeItem("userObj");
//     localStorage.removeItem("user");
//     localStorage.removeItem("userName");
//     localStorage.removeItem("UserName");
//     localStorage.removeItem("addedProducts");
//     localStorage.removeItem("userEmail");

//     // Clear cart
//     dispatch(clearCartData());
//     dispatch(clearCartLocal());
//     dispatch(logout());
//     persistor.purge();

//     setAuthToken(null);
//     toast.success("Logged out successfully");

//     // Navigate to login and then reload
//    setTimeout(() => {
//   window.location.href = "/login";
// }, 100);
// };
//   // const handleLogout = () => {
//   //   localStorage.removeItem("authToken"); // Remove token from localStorage
//   //   localStorage.removeItem("UserRowId");
//   //   localStorage.removeItem("redirect");
//   //   localStorage.removeItem("authToken");
//   //   localStorage.removeItem("userObj");
//   //   localStorage.removeItem("user");
//   //   localStorage.removeItem("userName");
//   //   localStorage.removeItem("UserName");
//   //   localStorage.removeItem("addedProducts");
//   //   // localStorage.removeItem("persist:root");
//   //    dispatch(clearCartData());
//   //    dispatch(clearCartLocal())

//   //   dispatch(logout());
//   //   persistor.purge();
//   //   setAuthToken(null);
//   //   toast.success("Logged out successfully");
//   //     setTimeout(() => {
//   //       console.log("After logout - cart data should be empty:", cart);
//   //   }, 500);
//   //   navigate("/login");
//   // };

//   // handel search results
//   const handleSearch = (event) => {
//     const value = event.target.value;
//     setSearchTerm(value);

//     try {
//       const response = dispatch(
//         getwebsiteProduct({
//           search: [
//             {
//               field: "name",
//               operation: "like",
//               value: value,
//             },
//           ],
//         })
//       );
//       console.log("response of global search response  on website ", response);
//     } catch (error) {
//       console.error("Error fetching  global search data:", error);
//     }
//   };
//   const clearSearch = () => {
//     dispatch(getwebsiteProduct());
//     setSearchTerm("");
//   };

//   return (
//     <>
//       <div className={`fixed w-full scrollbar top-0 z-30 transition-colors duration-500 ease-in-out ${isTop ? "bg-transparent text-white" : "bg-[#f7f7f7] text-[#661e33] border-b border-black-700"
//         }`}>

//         <nav
//           className={`py-2 border-b flex justify-between items-center transition-all duration-500 ${isTop
//             ? "bg-transparent text-[#661e33] border-transparent"
//             : "bg-[#f7f7f7] text-[#661e33] border-black-700 shadow-md"
//             }`}
//           style={{ height: `${isSearchOpen ? "120px" : "75px"}` }}
//         >

//           <div className="container mobile flex justify-between items-center md:mx-4 w-full">
//             <div className="flex-shrink-0 inline-block group">
//               <Link to="/homepage" className="relative" >
//                 <img src={logo} alt="Mobex Logo" className="inline-block h-16 md:h-20 lg:mx-0 md:m-0" style={{ position: "relative" }} />
//                 <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 !bg-black !text-white text-md px-2 py-1 rounded opacity-0  group-hover:!opacity-100 transition-opacity duration-300 z-[999]">
//                   Home
//                 </span>
//               </Link>
//             </div>
//             <div className="hidden md:flex lg:flex justify-between items-center flex-1">
//               <div className="flex justify-center items-center gap-8 mx-auto">

//               </div>

//               <div className="flex items-center gap-6 ml-auto">
//                 <div className="relative flex items-center bg-white w-[250px] border border-gray-300 text-black px-3 py-1 rounded-xl shadow-sm focus-within:ring-2 focus-within:ring-[#dff7eb] focus-within:border-[#dff7eb] transition duration-200">
//                   {/* Left Icon */}
//                   <FontAwesomeIcon icon={faMagnifyingGlass} rotation={90} className="text-gray-400 mr-2" />

//                   <input type="text" placeholder="Search..." className="flex-1 outline-none bg-transparent pr-8" />

//                   {/* Right Logo */}
//                   <img src={logowbg} alt="Logo" className="absolute right-2 w-7 h-7 object-contain" />
//                 </div>

//                  <Link to="/productpage" className="flex items-center px-0 py-2 text-[#661e33]" onClick={() => setDropdownVisible(false)}>
//                 <div className="relative">
//                     <Blinds size="22px" color="#661e33" className="hover:scale-105" />

//                   </div>
//                 </Link>

//                 <Link to="/shop" className="flex items-center px-0 py-2 text-[#661e33]" onClick={() => setDropdownVisible(false)}>
//                   <div className="relative">
//                     <FaShopify   size="22px" color="#661e33" className="hover:scale-105" />

//                   </div>
//                 </Link>

//                 <Link to="/account/wishlist" className="flex items-center px-0 py-2 text-[#661e33]" onClick={() => setDropdownVisible(false)}>
//                   <div className="relative">
//                     <Heart  className="text-xl hover:scale-105" />
//                     {wishlistCount > 0 && (
//                       <span className="absolute -top-1 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full px-0 py-0.5 min-w-[18px] text-center leading-none">{wishlistCount}</span>
//                     )}
//                   </div>
//                 </Link>
//                 <Link to="/addtocart" className="flex items-center px-0 py-2 text-[#661e33]" onClick={() => setDropdownVisible(false)}>
//                   <div className="relative">
//                     <FaShoppingCart className="text-xl hover:scale-105" />
//                     {cartCount > 0 && (
//                       <span className="absolute -top-1 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full px-0 py-0.5 min-w-[18px] text-center leading-none">{cartCount}</span>
//                     )}
//                   </div>
//                 </Link>
//                 {authToken === null ? (
//                   <div className="flex flex-end items-center" style={{ position: "relative", right: "4px" }}>
//                     <Link to="/login" className="text-white-500 no-underline font-bold">
//                       <button
//                         className="relative text-white font-bold no-underline cursor-pointer flex items-center whitespace-nowrap "
//                         type="button"
//                         onClick={toggleDropdown}
//                         style={{ position: "relative", right: "1px" }}
//                       >
//                         <FaUserPlus size="25px" color="#661e33" className="hover:scale-105" />
//                       </button>
//                     </Link>
//                   </div>
//                 ) : (
//                   <Link to="/account/dashboard" className="relative no-underline font-bold">
//                     <button
//                       className="relative text-white font-bold pl-2 no-underline cursor-pointer flex items-center whitespace-nowrap "
//                       type="button"
//                       // onClick={toggleDropdown}
//                       style={{ position: "relative", right: "1px" }}
//                     >
//                       <FaUser size="22px" color="#661e33" className="hover:scale-105" />
//                     </button>
//                   </Link>
//                 )}
//               </div>
//             </div>

//             {/* for mobile start */}
//             <div className="d-block d-sm-none flex items-center ">
//               {/* <button
//                 className="text-white px-2 py-2 h-12 rounded-lg"
//                 onClick={toggleSearchBar}
//               >
//                 <IoSearch size="30px" />
//               </button> */}
//               <div className="flex">
//                 <div className="flex  items-center gap-1 ">
//                   <div className="flex items-center relative">
//                     <Link to="/account/wishlist">
//                       <IoHeart size={"25px"} style={{ marginRight: "-16px" }} />
//                       <Circle size="4" bg="red" color="white" className="absolute -top-1 start-1.25">
//                         {wishlistCount}
//                       </Circle>
//                     </Link>
//                   </div>
//                   <div className="flex flex-bottom relative gap-3 ml-18 mx-6">
//                     <Link to="/addtocart">
//                       <IoCart size={"25px"} style={{ marginRight: "-16px" }} />
//                       <Circle size="4" bg="red" color="white" className="absolute -top-1 start-2 text-xs">
//                         {cartCount}
//                       </Circle>
//                     </Link>
//                   </div>

//                   {authToken === null ? (
//                     <div className="flex flex-end items-center" style={{ position: "relative", right: "8px" }}>
//                       <Link to="/login" className="text-white-500 no-underline font-bold">
//                         <button className="relative text-white-500  no-underline font-bold" type="button">
//                           {/* Login  */}
//                           <FaUserPlus size="25px" color="#661e33" className="hover:scale-105" />
//                         </button>
//                       </Link>

//                     </div>
//                   ) : (
//                     <Link className="relative no-underline font-bold">
//                       <button
//                         className="relative text-[#661e33] font-bold no-underline cursor-pointer flex items-center whitespace-nowrap "
//                         type="button"
//                         onClick={toggleDropdown}
//                         style={{ position: "relative", right: "1px" }}
//                       >
//                         <FaUser size="25px" />
//                       </button>
//                       {dropdownVisible && (
//                         <div className="absolute right-0 mt-2 w-[190px] bg-white shadow-lg rounded-md z-10">
//                           <Link to="/account/dashboard" className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200" onClick={() => setDropdownVisible(false)}>
//                             <FaTachometerAlt className="mr-2 text-sm" />
//                             Dashboard
//                           </Link>
//                           <Link to="/account/wishlist" className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200" onClick={() => setDropdownVisible(false)}>
//                             <Heart  className="mr-2 text-sm" />
//                             Wishlist
//                           </Link>
//                           <Link to="/account/orders" className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200" onClick={() => setDropdownVisible(false)}>
//                             <FaShoppingCart className="mr-2 text-sm" />
//                             Orders
//                           </Link>
//                           <Link to="/account/edit-address" className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200" onClick={() => setDropdownVisible(false)}>
//                             <FaMapMarkerAlt className="mr-2 text-sm" />
//                             Addresses
//                           </Link>
//                           <Link to="/account/edit-account" className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200" onClick={() => setDropdownVisible(false)}>
//                             <FaUser className="mr-2 text-sm" />
//                             Account details
//                           </Link>

//                           <Link
//                             className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200 border-t"
//                             onClick={() => {
//                               handleLogout();
//                               setDropdownVisible(false);
//                             }}
//                           >
//                             <FaSignOutAlt className="mr-2 text-sm" />
//                             Log out
//                           </Link>
//                         </div>
//                       )}
//                     </Link>
//                   )}
//                   <button className=" text-[#661e33] " onClick={openDrawer}>
//                     <IoMenuSharp className="h-6 w-7" />
//                   </button>
//                 </div>
//               </div>
//             </div>
//             {/* for mobile end */}
//           </div>

//         </nav>
//         {/* for mobile  */}
//         <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
//           <DrawerOverlay>
//             <DrawerContent>
//               <DrawerCloseButton />
//               <DrawerHeader style={{ fontWeight: "bold" }}>Menu</DrawerHeader>
//               <DrawerBody>
//                 <div className="flex flex-col items-center mt-2 w-full h-screen divide-y divide-slate-200">
//                   <Link to="/homepage" className="w-full  text-lg font-bold text-gray-800 no-underline cursor-pointer" onClick={onClose}>
//                     <div className="w-full p-2 hover:bg-[#EFF6FF]">Home</div>
//                   </Link>
//                   <Link
//                     to=""
//                     className="w-full  text-lg font-bold text-gray-800 no-underline cursor-pointer flex justify-between"
//                     onClick={() => {
//                       setIsHovered(!isHovered);
//                     }}
//                   >
//                     <div className="w-full p-2 hover:bg-[#EFF6FF] relative flex justify-between">
//                       Services {isHovered ? <ChevronDown /> : <ChevronUp />}
//                       {isHovered && (
//                         <div
//                           id="dropdownHover"
//                           // onMouseLeave={() => setIsHovered(false)}
//                           className="w-full divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700 absolute top-10 mt-2 transform transition-all duration-200 ease-out opacity-100 translate-y-0"
//                         >
//                           <ul className="py-2 px-3 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownHoverButton">
//                             <li onClick={onClose}>
//                               <Link to="/breaks" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Breaks
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/clutch" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Clutch & Transmissions
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <a href="#electrical" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Electrical
//                               </a>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/engine" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Engine Diagnostics
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/exhaust" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline text-shadow">
//                                 Exhaust
//                               </Link>
//                             </li>

//                             <li onClick={onClose}>
//                               <Link to="/fuel" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Fuel
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/maintenance" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Maintenance
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/radiators" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Radiators & Cooling
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/suspension" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Suspension & Steering
//                               </Link>
//                             </li>
//                             <li onClick={onClose}>
//                               <Link to="/transfer" className="px-2 block text-gray-700 py-2 hover:bg-gray-100 no-underline">
//                                 Transfer Case & Differentials
//                               </Link>
//                             </li>
//                           </ul>
//                         </div>
//                       )}
//                     </div>
//                   </Link>
//                   <Link to="/shop" className="w-full  text-lg font-bold text-gray-800 no-underline cursor-pointer" onClick={onClose}>
//                     <div className="w-full p-2 hover:bg-[#EFF6FF]">Shop</div>
//                   </Link>

//                   <Link to="/blog" className="w-full  text-lg font-bold text-gray-800 no-underline cursor-pointer" onClick={onClose}>
//                     <div className="w-full p-2 hover:bg-[#EFF6FF]">Blogs</div>
//                   </Link>
//                   <Link to="/about-us" className="w-full  text-lg font-bold text-gray-800 no-underline cursor-pointer" onClick={onClose}>
//                     <div className="w-full p-2 hover:bg-[#EFF6FF]">About us</div>
//                   </Link>
//                   <Link to="/contact-us" className="w-full  text-lg font-bold text-gray-800 no-underline cursor-pointer" onClick={onClose}>
//                     <div className="w-full p-2 hover:bg-[#EFF6FF]">Contact us</div>
//                   </Link>
//                 </div>
//               </DrawerBody>
//             </DrawerContent>
//           </DrawerOverlay>
//         </Drawer>
//       </div>
//     </>
//   );
// };

// export default NavBar;
